import { ServiceRequest } from "src/utils/service-request"
import { MOTOR_CADASTRO_VALIDACAO_PATH } from "../utils/api-routes"

class ValidacaoService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async getUltimaValidacao(id, dataReferencia) {
        const safeId = encodeURIComponent(id)
        const query = new URLSearchParams({ data_referencia: dataReferencia })

        const path = `${MOTOR_CADASTRO_VALIDACAO_PATH}/${safeId}/validacoes?${query}`

        return this.request.get(path)
    }

    async postValidacao(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_VALIDACAO_PATH}/${safeId}/validacoes`
        return this.request.post(path, payload)
    }
}

export default ValidacaoService